import React, { useState } from "react";
import { Link } from "react-router-dom";
import useCases from "../data/useCases";
import { INDUSTRIES, IndustryIcon, casesForIndustry } from "../data/industries";
import "./IndustryExplorer.css";

// Home page: pick an industry to see the value Aivio adds there and which agents apply, with an example for each.
function IndustryExplorer() {
  const [active, setActive] = useState(INDUSTRIES[0].key);
  const industry = INDUSTRIES.find((item) => item.key === active);
  const matches = casesForIndustry(active, useCases);

  // Arrow keys move between tabs, as in a standard tab list.
  const onKeyDown = (event) => {
    const step = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key];
    if (!step) return;
    event.preventDefault();
    const index = (INDUSTRIES.findIndex((item) => item.key === active) + step + INDUSTRIES.length) % INDUSTRIES.length;
    setActive(INDUSTRIES[index].key);
    document.getElementById(`industry-tab-${INDUSTRIES[index].key}`)?.focus();
  };

  return (
    <section className="industry-section" id="industries" data-reveal>
      <div className="container">
        <div className="industry-heading">
          <div><div className="eyebrow section-eyebrow">Industries</div><h2>Built for the work <span>your industry runs on.</span></h2></div>
          <p>From pharma and manufacturing to real estate and retail, Aivio’s agents fit into the processes that matter in your sector. Choose an industry to see where they help.</p>
        </div>

        <div className="industry-layout">
          <div className="industry-tabs" role="tablist" aria-label="Industries" aria-orientation="vertical" onKeyDown={onKeyDown}>
            {INDUSTRIES.map((item) => (
              <button type="button" role="tab" id={`industry-tab-${item.key}`} aria-selected={item.key === active} aria-controls="industry-panel" tabIndex={item.key === active ? 0 : -1}
                className={item.key === active ? "is-active" : ""} key={item.key} onClick={() => setActive(item.key)}>
                <IndustryIcon industry={item} /><span>{item.name}</span>
              </button>
            ))}
          </div>

          <div className="industry-panel" id="industry-panel" role="tabpanel" aria-labelledby={`industry-tab-${active}`} key={active}>
            <div className="industry-panel-head">
              <span className="industry-panel-icon"><IndustryIcon industry={industry} /></span>
              <div><small>HOW AIVIO ADDS VALUE</small><h3>{industry.name}</h3></div>
              <span className="industry-panel-count">{matches.length} agents</span>
            </div>
            <p className="industry-value">{industry.value}</p>
            <div className="industry-uses">
              {matches.map((item, index) => (
                <Link to={`/use-cases/${item.slug}`} className="industry-use" style={{ "--case-accent": item.accent, "--i": index }} key={item.slug}>
                  <span className="industry-use-label">{item.title}</span>
                  <span className="industry-use-text">{item.example}</span>
                  <span className="industry-use-arrow" aria-hidden="true">→</span>
                </Link>
              ))}
            </div>
            <div className="industry-panel-foot">
              <span>Every agent works within your permissions and pauses for approval where you decide.</span>
              <Link to={`/use-cases?industry=${active}#use-cases`}>See {industry.name} use cases →</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default IndustryExplorer;
